import { useState } from "react";
import { Loader2, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { useOutlook } from "./OutlookCard";

// Pushes this event's contacts into the connected Outlook account's Contacts.
export const OutlookContactsButton = ({ event, contacts, onDone }) => {
  const { status } = useOutlook();
  const [busy, setBusy] = useState(false);
  if (!status?.connected) return null;
  const todo = contacts.filter((c) => !c.outlook_contact_id && (c.email || c.phone));

  const push = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/events/${event.id}/outlook-contacts`, { contact_ids: todo.map((c) => c.id) }, { timeout: 120000 });
      toast.success(`Added ${data.added} to Outlook${data.skipped ? ` · ${data.skipped} already there` : ""}`);
      onDone();
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Couldn't add contacts to Outlook.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={push}
      disabled={busy || todo.length === 0}
      data-testid="event-outlook-contacts"
      className="mt-2 w-full h-11 rounded-full bg-[#0a64ad] text-white text-[11.5px] font-bold uppercase tracking-[0.1em] inline-flex items-center justify-center gap-2 disabled:opacity-50"
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <UserPlus className="h-4 w-4" />}
      {todo.length ? `Add ${todo.length} to Outlook contacts (${status.account_email})` : "All contacts are in Outlook"}
    </button>
  );
};

export default OutlookContactsButton;
